export const getReleaseNotes = async () => {
    const response = await fetch('/release-notes.json', {
        cache: 'no-store',
    });

    if (!response.ok) {
        throw new Error(`No se pudieron cargar las notas de versión (${response.status})`);
    }

    const payload = await response.json();
    return Array.isArray(payload?.versions) ? payload.versions : [];
};
